export default function FeatureCard({ Icon, title, description }) {
  return (
    <div className="bg-white rounded-3xl border border-gray-100 p-7 hover:-translate-y-2 hover:shadow-xl transition duration-300">
      <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 mb-5">
        <Icon size={18} />
      </div>

      <h3 className="font-bold text-xl text-gray-900 mb-3">{title}</h3>

      <p className="text-gray-500 leading-7">{description}</p>
    </div>
  );
}
